<template>
  <div>
    <b-breadcrumb style="margin-bottom:20px">
      <b-breadcrumb-item to="/">
        <feather-icon icon="HomeIcon" size="16" class="align-text-top" />
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/sales" v-if="permission.view"
        >Sales Order List</b-breadcrumb-item
      >
      <b-breadcrumb-item active>Detail Sales</b-breadcrumb-item>
    </b-breadcrumb>
    <b-card no-body>
      <b-card-body title="Detail Sales Order">
        <b-col cols="12">
          <b-row>
            <b-col cols="6">
              <b-row>
                <div class="d-flex flex-column">
                  <label>Purchase Order</label>
                  <b-link size="md" @click="toPurchase">
                    {{ poNumber[0] }}
                  </b-link>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Customer PO</label>
                  <p class="font-weight-bold">{{ poNumber[1] }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>RSP Order Number</label>
                  {{ sales.PONumber.includes("*")? sales.PONumber.substring(0, 11) : ""}}
                </div>
              </b-row>
              <b-row v-if="sales.dealer">
                <div class="d-flex flex-column">
                  <label>Dealer Name</label>
                  <p class="font-weight-bold">{{ sales.dealer.dealerName }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Industry Type</label>
                  <p class="font-weight-bold">{{ sales.distributionChannel }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Fullfillment Type</label>
                  <p class="font-weight-bold">{{ sales.orderType }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Order Status</label>
                  <p class="font-weight-bold">{{ sales.orderStatus }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>SO Status</label>
                  <p class="font-weight-bold">{{ sapStatus(sales.sapStatus) }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>SAP SO</label>
                  <p class="font-weight-bold">{{ sales.sapSo }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>SO Updated Date</label>
                  <p class="font-weight-bold">{{ datesWithTime(sales.soUpdatedDate, sales.updatedAt) }}</p>
                </div>
              </b-row>
            </b-col>

            <b-col cols="6">
              <b-row>
                <div class="d-flex flex-column" v-if="sales.deliveryType === 'End Customer'">
                  <label>Customer Name</label>
                  <p class="font-weight-bold">
                    {{
                      sales.customerDetail.type === "Company"
                        ? sales.customerDetail.companyName
                        : `${sales.customerDetail.firstName} ${sales.customerDetail.lastName}`
                    }}
                  </p>
                </div>

                <div class="d-flex flex-column" v-if="sales.deliveryType === 'Self Collect'">
                  <label>Customer Name</label>
                  <p class="font-weight-bold">
                    {{
                      sales.customerDetail.firstName === ""
                        ? "Not Set Up"
                        : `${sales.customerDetail.firstName} ${sales.customerDetail.lastName}`
                    }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Delivery Type</label>
                  <p class="font-weight-bold">{{ sales.deliveryType }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>PO Created by</label>
                  <p class="font-weight-bold" v-if="this.sales.createdBy === ''">
                    Not Set Up
                  </p>
                  <p class="font-weight-bold" size="md" v-if="this.sales.createdBy !== ''">
                    {{ sales.createdBy }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Purchase Date</label>
                  <p class="font-weight-bold">{{ dates(sales.createdAt) }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Delivery Date</label>
                  <p class="font-weight-bold">{{ dates(sales.deliveryDate) }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Remarks</label>
                  <p class="font-weight-bold">{{ sales.remarks }}</p>
                </div>
              </b-row>
            </b-col>
          </b-row>

          <b-row style="margin-top:25px;">
            <h5>Sales Order Item List</h5>
            <!-- Show regular item table for non-ekiosk sales -->
            <div v-if="!isEkioskPurchase" class="w-100">
              <b-table
                :items="sales.items"
                :fields="regularTableFields"
                bordered
                responsive
              >
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(model)="data">
                  {{ data.item.model }}
                </template>
                <template #cell(qty)="data">
                  {{ data.item.qty }}
                </template>
                <template #cell(unitPrice)="data">
                  {{ formatter(data.item.price.$numberDecimal) }}
                </template>
                <template #cell(amount)="data">
                  {{ formatter(parseInt(data.item.price.$numberDecimal)*data.item.qty) }}
                </template>
                <template #cell(reason)="data">
                  {{ data.item.reasonList }}
                </template>
              </b-table>
              
              <b-card class="pt-1">
                <b-row>
                  <b-col class="text-right font-weight-bold">Subtotal:</b-col>
                  <b-col cols="12" md="2" class="text-right">{{ formatter(sales.gstCalculation.total) }}</b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right font-weight-bold">GST {{ sales.gstCalculation.gst }}%:</b-col>
                  <b-col cols="12" md="2" class="text-right">{{ formatter(sales.gstCalculation.total*sales.gstCalculation.gst/100) }}</b-col>
                </b-row>
                <b-row class="mb-0">
                  <b-col class="text-right font-weight-bold">Grand Total:</b-col>
                  <b-col cols="12" md="2" class="text-right font-weight-bold">{{ formatter(sales.gstCalculation.grandTotal) }}</b-col>
                </b-row>
              </b-card>
            </div>
            
            <!-- Show ekiosk style table for ekiosk purchases -->
            <div v-if="isEkioskPurchase" class="w-100">
              <b-table
                :items="sales.items"
                :fields="ekioskTableFields"
                bordered
                responsive
              >
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(item)="data">
                  {{ getItemDetails(data.item).model }}
                </template>
                <template #cell(quantity)="data">
                  {{ getItemDetails(data.item).qty }}
                </template>
                <template #cell(unitPrice)="data">
                  {{ formatter(getItemDetails(data.item).price) }}
                </template>
                <template #cell(discountAmount)="data">
                  {{ formatter(getItemDetails(data.item).discountAmount) }}
                </template>
                <template #cell(discount)="data">
                  {{ getItemDetails(data.item).discountPercentage }}%
                </template>
                <template #cell(totalPrice)="data">
                  {{ formatter(getItemDetails(data.item).totalPrice) }}
                </template>
              </b-table>
              
              <b-card class="pt-1">
                <b-row>
                  <b-col class="text-right font-weight-bold">Subtotal after discount:</b-col>
                  <b-col cols="12" md="2" class="text-right">{{ formatter(sales.gstCalculation.total) }}</b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right font-weight-bold">GST {{ sales.gstCalculation.gst }}%:</b-col>
                  <b-col cols="12" md="2" class="text-right">{{ formatter(sales.gstCalculation.total*sales.gstCalculation.gst/100) }}</b-col>
                </b-row>
                <b-row class="mb-0">
                  <b-col class="text-right font-weight-bold">Total Price:</b-col>
                  <b-col cols="12" md="2" class="text-right font-weight-bold">{{ formatter(sales.gstCalculation.grandTotal) }}</b-col>
                </b-row>
              </b-card>
            </div>
          </b-row>
          
          <b-row style="margin-top:25px;">
            <h5>Delivery Order List</h5>
            <b-table :items="doList" :fields="doFields">
              <template #cell(sapDo)="row">
                <b-link size="md" @click="toDelivery(row.item)">
                  {{ row.item.sapDo }}
                </b-link>
              </template>
              <template v-slot:cell(deliveryDate)="row">
                {{ dates(row.item.deliveryDate) }}
              </template>
              <template #cell(status)="row">
                <step-progress-daikin :totalStep="(sales.deliveryType=='Self Collect')?3:4" :status="row.item.status"></step-progress-daikin>
              </template>
            </b-table>
          </b-row>
        </b-col>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import stepProgressDaikin from '@/components/StepProgressDaikin.vue'
import { userAccess, dateFormat,dateFormatFullWithSecond } from "@/utils/utils";

export default {
  props: ["idSales"],
  
  components: {
    stepProgressDaikin
  },
  data() {
    return {
      salesOrder: {
        SONumber: "-",
        orderType: "",
        orderStatus: "-",
        sapSo: "-",
        sapDo: "-",
        deliveryType: "-",
        deliveryDetail: {
          customerName: "-",
        },
        itemDetails: [],
      },
      doFields: [
        { key: "sapDo", label: "SAP DO" },
        { key: "sapInvoice", label: "Invoice Number" },
        { key: "status", label: "Status" },
      ],
      itemFields: [
        { key: "model", text: "Item Model" },
        { key: "qty", text: "Qty" },
        { key: "price", text: "Price" },
        // { key: 'rejectedQty', text: 'Rejected Qty' },
        { key: "rejectionReason", text: "Reason" },
      ],
      regularTableFields: [
        { key: "no", label: "No" },
        { key: "model", label: "Model" },
        { key: "qty", label: "Qty" },
        { key: "unitPrice", label: "Unit Price" },
        { key: "amount", label: "Amount" },
        { key: "reason", label: "Reason" }
      ],
      ekioskTableFields: [
        { key: "no", label: "No" },
        { key: 'item', label: 'Item' },
        { key: 'quantity', label: 'Quantity' },
        { key: 'unitPrice', label: 'Unit Price' },
        { key: 'discount', label: 'Discount' },
        { key: 'discountAmount', label: 'Discount Amount' },
        { key: 'totalPrice', label: 'Total Price' }
      ],
      doList:[]
    };
  },
  methods: {
    sapStatus(status){
      switch(status) {
        case 'A':
          return 'Ready'
        case 'B': 
          return 'Partially processed'
        case 'C':
          return 'Completely processed'
        case 'D':
          return 'Canceled'
        default:
          return `Unknown Status ${status}`
      }
    },
    getItemDetails(item) {
      const hasReplacement = item.availableReplacementQty != 0 && item.availableReplacementQty;
      const price = hasReplacement ? parseFloat((item.priceReplacement?.$numberDecimal) || 0) : parseFloat(item.price.$numberDecimal || 0);
      const qty = hasReplacement ? (item.updatedReplacementQty ?? item.availableReplacementQty) : (item.updatedQty ?? item.qty);
      const discountPercentage = hasReplacement ? ((item.unitDiscountReplacement) ?? (item.unitDiscount || 0)) : (item.unitDiscount || 0);
      const discountAmount = price * (discountPercentage / 100);
      const totalBeforeDiscount = price * qty;
      const totalAfterDiscount = totalBeforeDiscount - (totalBeforeDiscount * (discountPercentage / 100));
      
      return {
        model: hasReplacement ? ((item.replacementItem?.itemModel) || 'Replacement Item') : item.model,
        price: price,
        qty: qty,
        discountPercentage: discountPercentage,
        discountAmount: discountAmount,
        hasReplacement: hasReplacement,
        totalPrice: totalAfterDiscount
      };
    },
    dates(date) {
      return dateFormat(date);
    },
    datesWithTime(date, fallbackDate = null){
      return dateFormatFullWithSecond(date || fallbackDate)
    },
    async getDOList(sapSo) {
      //return [{sapDo:1,sapInvoice:1}]
      var filterDO = await this.$store.dispatch("delivery/getDeliveryOrder",{sapSo:'000'+sapSo})
        if(filterDO.data.length<=0){
          console.info("undefined")
          this.doList=[]
          return
        }

        var jData = filterDO.data.map((value)=>{
          return {
            id:value._id,
            sapDo:value.sapDo,
            sapInvoice:value.sapInvoice,
            status:value.status
          }
        })
        console.info('data ',jData)
        console.info('filterDO ',filterDO.data)
        this.doList=jData
        return
      
      
    },
    toPurchase() {
      var sapSo = this.sales.sapSo;
      var filterSO = this.purchaseOrder.find((x) => {
        return x.sapSo === sapSo;
      });
      this.$router.push({ name: "order-detail", params: { id: filterSO._id } });
    },
    toDelivery(doDetail) {
      //console.info('doDetail ',doDetail)
      this.$router.push({
        name: "warehouse-detail-delivery",
        params: { id: doDetail.id, from: "other" },
      });
    },
    formatter(value) {
      var number = value;
      if (!number) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
  },
  computed: {
    sales() {
      return this.$store.getters["sales/salesById"];
    },
    purchaseOrder() {
      return this.$store.getters["purchase/purchase"];
    },
    permission() {
      let result = userAccess("View Sales Order", "sales_order_menu");
      // console.log("View Sales Order",result)
      return result;
    },
    poNumber(){
      if(this.sales==undefined||this.sales.length<=0){
        return ["",""]
      }
      console.info('sales  ',this.sales)
      var split = this.sales.PONumber.split("*");
      return split;
    },
    isEkioskPurchase() {
      // Check if PO starts with EK
      if (this.poNumber && this.poNumber.length > 0) {
        return this.poNumber[0].startsWith('EK');
      }
      return false;
    },
  },
  mounted() {
    //this.$store.dispatch("delivery/getDeliveryOrder");

    this.$store.dispatch("purchase/getPurchase", { orderStatus: "ALL" });

    this.$store
      .dispatch("sales/detailSales", {
        id: this.idSales,
      })
      .then((res)=>{
        this.getDOList(this.sales.sapSo)
      })
      .catch((err) => {
        console.log({ err });
      });
  },
};
</script>
